import { FC, useRef } from 'react';

import { AppProps } from './App.types';
import { AppContextComponent } from './context';
import { useIFrameHeight } from './hooks/useIFrameHeight';
import { AppRouter } from './routers/AppRouter';
import { LanguageRouter } from './routers/LanguageRouter';

const containerId = 'argnt-vacancies-root-id';

export const App: FC<AppProps> = ({ config }) => {
  const scrollElement = useRef<HTMLDivElement>(null);
  const {
    toggles: {
      ops: { enableIFrameInteraction },
    },
  } = config;
  useIFrameHeight('root', enableIFrameInteraction);

  return (
    <div className="argnt-vacancies" id={containerId} ref={scrollElement}>
      <AppContextComponent config={config}>
        <LanguageRouter>
          <AppRouter scrollElement={scrollElement} />
        </LanguageRouter>
      </AppContextComponent>
    </div>
  );
};
